"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var Search_1 = require("./Search");

var withResponsiveDesign = fclasses_1.withDesign({
  Wrapper: fclasses_1.addClasses('lg:hidden'),
  ToggleButton: fclasses_1.addClasses('h-full')
});

var responsiveSearchComponents = __assign(__assign({}, Search_1.searchComponents), {
  Wrapper: fclasses_1.Div,
  ToggleButton: fclasses_1.Button,
  ToggleIcon: fclasses_1.addClasses('material-icons cursor-pointer align-middle')(fclasses_1.I)
});

var ResponsiveSearchBoxBase = function ResponsiveSearchBoxBase(props) {
  var _a = react_1.useState(false),
      isExpanded = _a[0],
      setExpanded = _a[1];

  var components = props.components;
  var Wrapper = components.Wrapper,
      ToggleButton = components.ToggleButton,
      ToggleIcon = components.ToggleIcon;
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(ToggleButton, {
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    }
  }, react_1.default.createElement(ToggleIcon, null, isExpanded ? 'close' : 'search')), react_1.default.createElement(Search_1.SearchBox, __assign({}, props, {
    style: {
      display: isExpanded ? 'flex' : 'none'
    }
  })));
};

var ResponsiveSearchBox = lodash_1.flow(fclasses_1.designable(responsiveSearchComponents, 'ResponsiveSearchBox'), withResponsiveDesign)(ResponsiveSearchBoxBase);
exports.default = ResponsiveSearchBox;